import { displayedText, SUBMITTED_FIELDS } from '../../model/helpers'
import { TSubmittedValues } from '../../model/types'
import { COMPETITOR_BAD_ACTOR_REVIEW_TEXT as TEXT, useReviewText } from '../translations'

import styles from './SubmittedValues.module.scss'

interface ISubmittedValuesProps {
  submitted: TSubmittedValues
}

export const SubmittedValues = ({ submitted }: ISubmittedValuesProps) => {
  const text = useReviewText()
  const noValue = text(TEXT.noValue)

  return (
    <dl className={styles.list}>
      {SUBMITTED_FIELDS.map((field) => (
        <div key={field} className={styles.pair}>
          <dt>{text(TEXT.submittedField[field])}</dt>
          <dd>{displayedText(submitted[field], noValue)}</dd>
        </div>
      ))}
    </dl>
  )
}
